import ChristmasLogo from '@henwend/modules/christmas/logo';
import { makeAutoObservable } from 'mobx';
import React from 'react';

// import Logo from '@/components/logo';
import Avatar from '@/modules/game/Avatar';

export interface headersType {
  left?: React.ReactNode;
  right?: React.ReactNode;
  title?: React.ReactNode;
}

export const layoutStore = makeAutoObservable({
  headers: {
    left: <ChristmasLogo />,
    right: <Avatar />,
    title: null,
    style: {
      height: '1.2rem'
    }
  } as headersType,
  style: {
    height: '1.2rem'
  } as Record<string, any>,
  hideNavbar: false,
  hideHeader: false,

  setHeader({ left = <ChristmasLogo />, right = <Avatar />, title = null }: headersType) {
    this.headers = {
      left,
      right,
      title
    };
  },
  setNavbar(hideNavbar: boolean) {
    this.hideNavbar = hideNavbar;
  },
  setHideHeader(hideHeader: boolean) {
    this.hideHeader = hideHeader;
  },
  setStyle(style: Record<string, any> = {}) {
    this.style = {
      height: '1.2rem',
      ...style
    };
  }
});
